import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { PublicationWageType } from './publication-wage-type.interface';
import { PublicationWageTypeService } from './publication-wage-type.service';

const service = new PublicationWageTypeService();

export interface PublicationWageTypeState {
   publicationWageTypes: Array<PublicationWageType>;
}

const PublicationWageTypeStore: Module<PublicationWageTypeState, StoreState> = {
   namespaced: true,
   state: {
      publicationWageTypes: [],
   },
   getters: {},
   mutations: {
      SET_PUBLICATION_WAGE_TYPES(state, publicationWageTypes: Array<PublicationWageType>) {
         state.publicationWageTypes = publicationWageTypes;
      },
   },
   actions: {
      async getPublicationWageTypes(context, query: LocationQuery) {
         const response = await service.getPublicationWageTypes({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_PUBLICATION_WAGE_TYPES', response.data);
         return response;
      },
   },
};

export default PublicationWageTypeStore;
